"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVehicleConnectLinkTokenV1 = exports.postVehicleConnectResultV1 = exports.getSupportedBrandsV1 = exports.getVehicleStatusV1 = exports.getVehicleScheduleV1 = exports.getVehicleImageV1 = exports.putTargetchargeV1 = exports.putMinimumchargeV1 = exports.putIsboostmodeactiveV1 = exports.putFullchargedeadlineV1 = exports.putDeactivateV1 = exports.putActivateV1 = exports.getVehicleChargeSessionsV1 = exports.getVehicleChargeSessionV1 = exports.putLikeV1 = exports.postFeedbackV1 = exports.putDislikeV1 = exports.putScheduleV1 = exports.getChargePolicyScheduleV1 = exports.postSubscriptionsV1 = exports.deleteSubscriptionsV1 = exports.postSubscriptionConsentsV1 = exports.getLookupV1 = exports.getEligibilityV1 = exports.getSmartChargingDetailsV1 = void 0;
/**
 * Returns if the customer is enrolled for smart-charging; If the customer is a Smart Charging customer, it returns static smart charging details.
 * @param data The data for the request.
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns GetSmartChargingDetailsResponse OK
 * @throws ApiError
 */
const getSmartChargingDetailsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/details/v1',
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getSmartChargingDetailsV1 = getSmartChargingDetailsV1;
/**
 * Checks if a customer is eligible for a Smart Charging subscription on a particular address.
 * @param data The data for the request.
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns GetEligibilityResponse OK
 * @throws ApiError
 */
const getEligibilityV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/eligibility/v1',
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getEligibilityV1 = getEligibilityV1;
/**
 * Looks up the license plate if it's applicable for smart charging.
 * @param data The data for the request.
 * @param data.licensePlate A dutch license plate that needs to be looked up for smart charging eligibility. The license plate can be provided with or without dashes.
 * @returns LicensePlateLookupResponse OK
 * @throws ApiError
 */
const getLookupV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/licenseplate/lookup/v1',
        query: {
            license_plate: data.licensePlate
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getLookupV1 = getLookupV1;
/**
 * Updates the subscription consents
 * @param data The data for the request.
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const postSubscriptionConsentsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/smart-charging/subscription/consents/v1',
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postSubscriptionConsentsV1 = postSubscriptionConsentsV1;
/**
 * Unsubscribes a supply address from Smart Charging
 * @param data The data for the request.
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const deleteSubscriptionsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'DELETE',
        url: '/smart-charging/subscriptions/v1',
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.deleteSubscriptionsV1 = deleteSubscriptionsV1;
/**
 * Subscribes a supply address to Smart Charging
 * @param data The data for the request.
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const postSubscriptionsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/smart-charging/subscriptions/v1',
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postSubscriptionsV1 = postSubscriptionsV1;
/**
 * Returns the charge policy schedule for the given vehicleId.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns GetChargePolicyScheduleResponse OK
 * @throws ApiError
 */
const getChargePolicyScheduleV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/vehicles/{vehicleId}/chargepolicy/schedule/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getChargePolicyScheduleV1 = getChargePolicyScheduleV1;
/**
 * Changes the charge policy for one or more days of the week
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putScheduleV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargepolicy/schedule/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putScheduleV1 = putScheduleV1;
/**
 * Marks a charge session as disliked by the customer.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.sessionId The unique identifier of the charge session
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putDislikeV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargesessions/{sessionId}/dislike/v1',
        path: {
            vehicleId: data.vehicleId,
            sessionId: data.sessionId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putDislikeV1 = putDislikeV1;
/**
 * Gives feedback on a charge session by the customer.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.sessionId The unique identifier of the charge session
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const postFeedbackV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/smart-charging/vehicles/{vehicleId}/chargesessions/{sessionId}/feedback/v1',
        path: {
            vehicleId: data.vehicleId,
            sessionId: data.sessionId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postFeedbackV1 = postFeedbackV1;
/**
 * Marks a charge sessionas liked by the customer.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.sessionId The unique identifier of the charge session
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putLikeV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargesessions/{sessionId}/like/v1',
        path: {
            vehicleId: data.vehicleId,
            sessionId: data.sessionId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putLikeV1 = putLikeV1;
/**
 * Returns the vehicle charge session for the given sessionId.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.sessionId The unique identifier of the charge session
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns GetChargeSessionResponse OK
 * @throws ApiError
 */
const getVehicleChargeSessionV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/vehicles/{vehicleId}/chargesessions/{sessionId}/v1',
        path: {
            vehicleId: data.vehicleId,
            sessionId: data.sessionId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getVehicleChargeSessionV1 = getVehicleChargeSessionV1;
/**
 * Returns the vehicle charge sessions for given time period.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @param data.fromDate The start date from which to retrieve the charge sessions
 * @param data.toDate The end date until which to retrieve the charge sessions
 * @param data.includeNotAtHome A filter to include charge sessions that did not happen at home. If not passed, only home sessions will be returned.
 * @returns GetChargeSessionsResponse OK
 * @throws ApiError
 */
const getVehicleChargeSessionsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/vehicles/{vehicleId}/chargesessions/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId,
            from_date: data.fromDate,
            to_date: data.toDate,
            include_not_at_home: data.includeNotAtHome
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getVehicleChargeSessionsV1 = getVehicleChargeSessionsV1;
/**
 * Activates the vehicle's charging policy.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putActivateV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargingpolicy/activate/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putActivateV1 = putActivateV1;
/**
 * Deactivates the vehicle's charging policy.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putDeactivateV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargingpolicy/deactivate/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putDeactivateV1 = putDeactivateV1;
/**
 * Updates the full charge deadline of the vehicle's charging policy.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putFullchargedeadlineV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargingpolicy/fullchargedeadline/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putFullchargedeadlineV1 = putFullchargedeadlineV1;
/**
 * Activates or deactivates boost charging for the vehicle.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putIsboostmodeactiveV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargingpolicy/isboostmodeactive/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putIsboostmodeactiveV1 = putIsboostmodeactiveV1;
/**
 * Updates the minimum charge of the vehicle's charging policy.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putMinimumchargeV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargingpolicy/minimumcharge/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putMinimumchargeV1 = putMinimumchargeV1;
/**
 * Updates the target charge of the vehicle's charging policy.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const putTargetchargeV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PUT',
        url: '/smart-charging/vehicles/{vehicleId}/chargingpolicy/targetcharge/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.putTargetchargeV1 = putTargetchargeV1;
/**
 * Returns the vehicle's image.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns GetVehicleImageResponse OK
 * @throws ApiError
 */
const getVehicleImageV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/vehicles/{vehicleId}/image/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getVehicleImageV1 = getVehicleImageV1;
/**
 * Returns the vehicle's schedule.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns GetVehicleScheduleResponse OK
 * @throws ApiError
 */
const getVehicleScheduleV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/vehicles/{vehicleId}/schedule/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getVehicleScheduleV1 = getVehicleScheduleV1;
/**
 * Returns the vehicle status.
 * @param data The data for the request.
 * @param data.vehicleId The unique identifier of the vehicle
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns GetVehicleStatusResponse OK
 * @throws ApiError
 */
const getVehicleStatusV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/vehicles/{vehicleId}/status/v1',
        path: {
            vehicleId: data.vehicleId
        },
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getVehicleStatusV1 = getVehicleStatusV1;
/**
 * Returns the supported vehicle brands.
 * @returns GetSupportedBrandsResponse OK
 * @throws ApiError
 */
const getSupportedBrandsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/smart-charging/vehicles/brands/v1',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getSupportedBrandsV1 = getSupportedBrandsV1;
/**
 * Allows posting the result of a vehicle connection attempt to an external vendor
 * @param data The data for the request.
 * @param data.supplyAddressId The supply address identifier key
 * @param data.requestBody
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @returns unknown OK
 * @throws ApiError
 */
const postVehicleConnectResultV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/smart-charging/vehicles/connect/result/v1',
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postVehicleConnectResultV1 = postVehicleConnectResultV1;
/**
 * Returns authentication token needed to connect a vehicle using an external vendor SDK
 * @param data The data for the request.
 * @param data.supplyAddressId The supply address identifier key
 * @param data.accountId The requesting user's account id. Must be provided through either headers or query params.
 * @param data.vehicleBrand The brand of the vehicle to be connected
 * @param data.redirectUrl URL to redirect to after the vehicle was connected successfully
 * @returns GetVehicleConnectLinkTokenResponse OK
 * @throws ApiError
 */
const getVehicleConnectLinkTokenV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/smart-charging/vehicles/connect/v1',
        query: {
            supply_address_id: data.supplyAddressId,
            account_id: data.accountId,
            vehicle_brand: data.vehicleBrand,
            redirect_url: data.redirectUrl
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getVehicleConnectLinkTokenV1 = getVehicleConnectLinkTokenV1;
